import { Block, Container, Heading, RichText } from '~/components'
import * as styles from './ChefMenuBlock.css'
import type { ChefMenuBlock } from './types'

type Props = {
  block: ChefMenuBlock
}

export function ChefMenuBlock({ block }: Props) {
  return (
    <Block options={block.options}>
      <Container>
        <div className={styles.content}>
          <div className={styles.main}>
            <Heading margin="medium">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" className={styles.icon}>
                <path fill="none" d="M0 0h256v256H0z" />
                <path
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={16}
                  d="M128 88a32 32 0 0 1 32-32h64a8 8 0 0 1 8 8v128a8 8 0 0 1-8 8h-64a32 32 0 0 0-32 32M24 192a8 8 0 0 0 8 8h64a32 32 0 0 1 32 32V88a32 32 0 0 0-32-32H32a8 8 0 0 0-8 8Z"
                />
              </svg>
              {block.title}
            </Heading>
            <div className={styles.text}>{block.richtext && <RichText content={block.richtext} />}</div>
          </div>
        </div>
      </Container>
    </Block>
  )
}
